export const GET_PARTY_CHALLENGE_LEVEL = "GET_PARTY_CHALLENGE_LEVEL";
export const EDIT_ITEM = "EDIT_ITEM";
export const OPEN_PARTY_CHALLENGE_DIALOG = "OPEN_PARTY_CHALLENGE_DIALOG";
export const CLOSE_PARTY_CHALLENGE_DIALOG = "CLOSE_PARTY_CHALLENGE_DIALOG";
export const REOPEN_TREASURE_BOX = "REOPEN_TREASURE_BOX";